import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useIsQuestionnaireReadOnly } from '../../common/hooks';

import type { RootState } from '../../../../store';

export default function useIsIntakeQuestionnaireReadOnly() {
  const details = useSelector(
    (state: RootState) => state.intakeQuestionnaire.intakeQuestionnaireDetails,
  );
  const { intakeQuestionnaireId } = useParams<'intakeQuestionnaireId'>();

  return useIsQuestionnaireReadOnly(details, intakeQuestionnaireId);
}
